import type {
  DataTableColumn as GridColDef,
  DataTableRenderCellParams as GridCellParams
} from '@/components/custom/erp';
import { formatMoney } from '@/lib/formatUtils';

const isSummaryRow = (row: MuaHangRecord): boolean => {
  return (
    row?.stt === null || row?.document_uuid === 'SUMMARY' || row?.ten_kh === 'Tổng cộng' || row?.id === 'total-row'
  );
};

const getSummaryCellClass = (params: GridCellParams): string => {
  return isSummaryRow(params.row) ? 'font-bold' : '';
};

export const invoiceReportColumns = (handleDocumentFormClick: (obj: MuaHangRecord) => void): GridColDef[] => [
  {
    field: 'unit_id',
    headerName: 'Đơn vị',
    width: 100,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ngay_ct',
    headerName: 'Ngày c/từ',
    width: 110,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'so_ct',
    headerName: 'Số c/từ',
    width: 140,
    cellClassName: getSummaryCellClass,
    renderCell: params => {
      if (isSummaryRow(params.row)) {
        return <span className='font-bold'>{params.value}</span>;
      }
      return (
        <button onClick={() => handleDocumentFormClick(params.row)} className='hover:text-blue-500 hover:underline'>
          {params.value}
        </button>
      );
    }
  },
  {
    field: 'ma_kh',
    headerName: 'Mã NCC',
    width: 100,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ten_kh',
    headerName: 'Tên NCC',
    width: 200,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 200,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_vt',
    headerName: 'Mã vật tư',
    width: 120,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ten_vt',
    headerName: 'Tên vật tư',
    width: 200,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'dvt',
    headerName: 'ĐVT',
    width: 80,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'sl_xuat',
    headerName: 'Số lượng',
    width: 100,
    type: 'number',
    align: 'right',
    cellClassName: getSummaryCellClass,
    renderCell: params => (
      <span className={isSummaryRow(params.row) ? 'font-bold' : ''}>{formatMoney(params.value)}</span>
    )
  },
  {
    field: 'gia',
    headerName: 'Giá',
    width: 120,
    type: 'number',
    align: 'right',
    cellClassName: getSummaryCellClass,
    renderCell: params => (
      <span className={isSummaryRow(params.row) ? 'font-bold' : ''}>{formatMoney(params.row.gia)}</span>
    )
  },
  {
    field: 'tien_xuat',
    headerName: 'Tiền hàng',
    width: 120,
    type: 'number',
    align: 'right',
    cellClassName: getSummaryCellClass,
    renderCell: params => (
      <span className={isSummaryRow(params.row) ? 'font-bold' : ''}>{formatMoney(params.value)}</span>
    )
  },
  {
    field: 'thue',
    headerName: 'Thuế',
    width: 100,
    type: 'number',
    align: 'right',
    cellClassName: getSummaryCellClass,
    renderCell: params => (
      <span className={isSummaryRow(params.row) ? 'font-bold' : ''}>{formatMoney(params.row.thue)}</span>
    )
  },
  {
    field: 'tong_tt',
    headerName: 'Tổng thanh toán',
    width: 130,
    type: 'number',
    align: 'right',
    cellClassName: getSummaryCellClass,
    renderCell: params => (
      <span className={isSummaryRow(params.row) ? 'font-bold' : ''}>{formatMoney(params.value)}</span>
    )
  },
  {
    field: 'tk_du',
    headerName: 'TK nợ',
    width: 120,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 130,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 100,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 130,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 130,
    cellClassName: getSummaryCellClass
  },
  {
    field: 'ma_ct',
    headerName: 'Mã c/từ',
    width: 120,
    cellClassName: getSummaryCellClass
  }
];
